// extracted by mini-css-extract-plugin
export default {"card":"KZ-z","carouselContainer":"LZ-z","carouselContent":"MZ-z"};